import { createQueryKeys } from "@lukemorales/query-key-factory";
import { GetUserRequest, GetUsersRequest } from "@/Stub/V1";

export const Users = createQueryKeys('users', {
    list: (requestParams?: GetUsersRequest) => [{ requestParams }],
    detail: (requestParams?: GetUserRequest) => [{ requestParams }],
});
